import { render } from "./tabReproductor.vue?vue&type=template&id=3f1a8808&scoped=true"
import script from "./tabReproductor.vue?vue&type=script&lang=js"
export * from "./tabReproductor.vue?vue&type=script&lang=js"

import "./tabReproductor.vue?vue&type=style&index=0&id=3f1a8808&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1a8808"]])

export default __exports__